export default "__VITE_PUBLIC_ASSET__63076360__"